import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { LoginModel } from './model/LoginModel';
import { LoginController } from './controller/LoginController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem, Navigation } from 'utils/Navigation';
import { AuthCard } from '../AuthCard';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class LoginScene extends AScene<Props, LoginModel, LoginController> {

    private email: string = "";
    private password: string = "";

    public constructor(props: Props) {
        super(props);

        this.handleLoginClicked = this.handleLoginClicked.bind(this);
        this.handleCancelClicked = this.handleCancelClicked.bind(this);
    }

    protected createControlller(): LoginController {
        return new LoginController();
    }

    private handleLoginClicked() {
        this.controller.onLoginClicked(this.email, this.password);
    }

    private handleCancelClicked() {
        this.controller.onCancelClicked();
    }

    public render(): React.ReactNode {
        this.email = this.model.email;
        this.password = this.model.password;
        return (
            <AuthCard title="Login" error={this.model.error}>
                <TextField label="Email" value={this.model.email} onChange={(v) => { this.email = v; }} />
                <TextField label="Password" type="password" value={this.model.password} onChange={(v) => { this.password = v; }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '8px' }}>
                    <Button color="secondary" onClick={this.handleCancelClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleLoginClicked}>Login</Button>
                </div>
                <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '14px' }}>
                    <a href="/forgotPassword.rsc" style={{ color: '#009155' }} onClick={(e) => { e.preventDefault(); Navigation.pushState(null, "/forgotPassword.rsc"); }}>Forgot password?</a>
                </div>
                <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '14px', color: '#888' }}>
                    Don't have an account?{' '}
                    <a href="/register.rsc" style={{ color: '#009155' }} onClick={(e) => { e.preventDefault(); Navigation.pushState(null, "/register.rsc"); }}>Sign up</a>
                </div>
            </AuthCard>
        );
    }

}

export class Props {

}

export class LoginSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <LoginScene />
        );
    }

}
